// extracted by mini-css-extract-plugin
module.exports = {"Badge":"_5Y2Bd","Badge__Icon":"gxgYr","pvi-no-styles":"xZX3E"};